export const admins = '/users/admins';
export const admin = (id: number) => `/users/admins/${id}`;
export const download = 'users/download/admins';
